import { mutatorAction } from 'satcheljs';
import { inlineFeedbackDialogStore } from '../store/store';

export let setFeedbackCategories = mutatorAction(
    'setFeedbackCategories',
    (inlineFeedbackSuggestion: string, checked: boolean) => {
        let store = inlineFeedbackDialogStore();
        if (checked && !store.subCategories.has(inlineFeedbackSuggestion)) {
            store.subCategories.set(inlineFeedbackSuggestion, []);
        }
        if (!checked && store.subCategories.has(inlineFeedbackSuggestion)) {
            store.subCategories.delete(inlineFeedbackSuggestion);
        }
    }
);
